import { HorseLink, TrainerLink } from '../../shared/links/ProfileLink';
import WonCell from './WonCell';
import { sortByDate } from '../../utils/date';
import UpcomingRaceCell from './UpcomingRaceCell';
import TravellersRaceCell from './TravellersRaceCell';

const horseCol = {
    key: 'horseStyleName',
    header: 'horse',
    cell: HorseLink,
    sortFn: 'alphabetic',
};

const timeCol = {
    key: 'raceDatetime',
    header: 'race',
    cell: TravellersRaceCell,
    sortFn: sortByDate('raceDatetime', true),
};

const trainerCol = {
    key: 'trainerStyleName',
    header: 'trainer',
    cell: TrainerLink,
    sortFn: 'byLastName',
};

const milesCol = { key: 'miles' };

const timeCol2 = {
    key: 'upcomingRace',
    header: 'race',
    cell: UpcomingRaceCell,
    sortFn: sortByDate('upcomingRace.raceDatetime', true),
};

const wonCol = {
    key: 'raceInstanceUid',
    header: 'race won',
    cell: WonCell,
};

export default {
    travelersCheck: [horseCol, trainerCol, timeCol, milesCol],
    firstTimeBlinkers: [horseCol, timeCol],
    sevenDayWinners: [horseCol, timeCol2, wonCol],
};



// WEBPACK FOOTER //
// ./src/js/course/signposts/columns.js